export const trip = {
  title: 'Banff & the Canadian Rockies',
  dates: 'October 3–10, 2026',
  shortDates: 'Oct 3 – Oct 10',
  nights: 7,
  travelers: ['Brandon', 'Alex', 'Contir', 'Miller Time'],
  lodgingBudget: 8000,
  destination: 'Banff, Alberta, Canada',
  rental: 'Avis President’s Club',
}

export const officialLinks = {
  parksTransit: 'https://parks.canada.ca/pn-np/ab/banff/visit/parkbus/louise',
  parksFaq: 'https://parks.canada.ca/pn-np/ab/banff/visit/parkbus/louise/faq',
  roam: 'https://roamtransit.com/reservations/',
  gondola: 'https://www.banffjaspercollection.com/attractions/banff-gondola/',
  minnewanka: 'https://www.banffjaspercollection.com/attractions/lake-minnewanka-cruise/',
  icefield: 'https://www.banffjaspercollection.com/attractions/columbia-icefield/',
  road: 'https://511.alberta.ca/',
  trails: 'https://parks.canada.ca/pn-np/ab/banff/activ/randonnee-hiking',
  weather: 'https://weather.gc.ca/en/location/index.html?coords=51.178,-115.571',
}

export const bookingChecklist = [
  'Book lodging',
  'Reserve Lake Louise / Moraine Lake transportation',
  'Reserve Banff Gondola / Sky Bistro if selected',
  'Reserve top dinners',
  'Reserve Columbia Icefield Adventure if selected',
  'Confirm Lake Minnewanka cruise seasonal operation',
  'Reserve Avis vehicle',
  'Buy or rent bear spray after arrival',
]
